export const API_PROJECTS_NUMBERS_DESC_COMPONENT_FIELDS = [
    'projects_number_desc_component.projects_number_desc_component_id'
];
